document.addEventListener('DOMContentLoaded', function(e) {
    let grantApp = document.querySelector('section.form-wrapper.grant-application');
    if (grantApp) {
        let fragment = location.search;
        let grant_type = grantApp.querySelector('select[name="_subject"]');

        let options = grant_type.querySelectorAll('option');

        options.forEach(option => {
            if (fragment.includes(option.dataset.slug)) {
                grant_type.children[0].selected = false;
                option.selected = true;
            }
        })
    }
})